const REPLACE_RFP_PRO_OFFER_FORM = 'REPLACE_RFP_PRO_OFFER_FORM';
const UPDATE_RFP_PRO_OFFER_FORM_ASSIGN = 'UPDATE_RFP_PRO_OFFER_FORM_ASSIGN';
const UPDATE_RFP_PRO_OFFER_FORM_OFFER = 'UPDATE_RFP_PRO_OFFER_FORM_OFFER';
const UPDATE_RFP_PRO_OFFER_FORM_PAYMENT = 'UPDATE_RFP_PRO_OFFER_FORM_PAYMENT';
const ADD_RFP_PRO_OFFER_FORM_MEMBER = 'ADD_RFP_PRO_OFFER_FORM_MEMBER';
const UPDATE_RFP_PRO_OFFER_FORM_MEMBER = 'UPDATE_RFP_PRO_OFFER_FORM_MEMBER';
const RESET_RFP_PRO_OFFER_FORM = 'RESET_RFP_PRO_OFFER_FORM';
/**
 * Form の値置き換え用
 * @param values
 */
export const replaceRfpProOfferFormAction = (values) => ({
    payload: values,
    type: REPLACE_RFP_PRO_OFFER_FORM,
});
/**
 * Form の assign 値更新用 action
 * @param values
 */
export const updateRfpProOfferAssignAction = (values) => ({
    payload: values,
    type: UPDATE_RFP_PRO_OFFER_FORM_ASSIGN,
});
/**
 * Form の offer 値更新用 action
 * @param values
 */
export const updateRfpProOfferAction = (values) => ({
    payload: values,
    type: UPDATE_RFP_PRO_OFFER_FORM_OFFER,
});
/**
 * Form の payment 値更新用 action
 * @param values
 */
export const updateRfpProOfferPaymentAction = (values) => ({
    payload: values,
    type: UPDATE_RFP_PRO_OFFER_FORM_PAYMENT,
});
/**
 * Form の member 追加用 action
 * @param values
 */
export const addRfpProOfferMemberAction = (values) => ({
    payload: values,
    type: ADD_RFP_PRO_OFFER_FORM_MEMBER,
});
/**
 * Form の member 値更新用 action
 * @param values
 */
export const updateRfpProOfferMemberAction = (values) => ({
    payload: values,
    type: UPDATE_RFP_PRO_OFFER_FORM_MEMBER,
});
/**
 * Form 初期化用 action
 * @param formValues
 */
export const resetRfpProOfferAction = () => ({ type: RESET_RFP_PRO_OFFER_FORM });
/**
 * 初期値
 */
export const initialState = {
    assign: false,
    offer: {
        additional_files: [],
        answer: '',
        candidate_interview_date: '',
        file: undefined,
        free_description: '',
        max_period: null,
        max_price: null,
        period: null,
        price: null,
        summary: '',
    },
    payment: {
        billing_information: [],
        options: null,
    },
    rfp_offer_members: [],
};
export const reducer = (state, action) => {
    const currentState = state || initialState;
    switch (action.type) {
        case REPLACE_RFP_PRO_OFFER_FORM:
            return action.payload;
        case UPDATE_RFP_PRO_OFFER_FORM_ASSIGN:
            return Object.assign(Object.assign({}, currentState), { assign: action.payload });
        case UPDATE_RFP_PRO_OFFER_FORM_OFFER:
            return Object.assign(Object.assign({}, currentState), { offer: action.payload });
        case UPDATE_RFP_PRO_OFFER_FORM_PAYMENT:
            return Object.assign(Object.assign({}, currentState), { payment: action.payload });
        case ADD_RFP_PRO_OFFER_FORM_MEMBER:
            return Object.assign(Object.assign({}, currentState), { rfp_offer_members: [...currentState.rfp_offer_members, action.payload] });
        case UPDATE_RFP_PRO_OFFER_FORM_MEMBER:
            return Object.assign(Object.assign({}, currentState), { rfp_offer_members: action.payload });
        case RESET_RFP_PRO_OFFER_FORM:
            return initialState;
        default:
            return currentState;
    }
};
